import { useState, useEffect } from 'react';

import { IWindowResizeReturnValue } from './interfaces';

export function useWindowResize(): IWindowResizeReturnValue {
  const [windowSize, setWindowSize] = useState<{
    height: number;
    width: number;
  }>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    function handleResize(): void {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
